import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

import { VendorAdminService } from "../../../services/api/vendor-admin.service";
import { VendorAdminActions } from "../../actions/vendor-admin.actions";
import { FailState } from "../../models/fail-state";
import { UsersState } from "../../models/users-state";
import { AppState } from "../../reducers";
import { UsersSelectors } from "../../selectors/users.selectors";

@Injectable()
export class VendorUsersGetEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(VendorAdminActions.users.get),
			withLatestFrom(this.store.select(UsersSelectors.users)),
			switchMap(([, state]) =>
				this.canUserStoreValue(state)
					? of(VendorAdminActions.users.getSuccess(state))
					: of(VendorAdminActions.users.getApi())
			)
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(VendorAdminActions.users.getApi, VendorAdminActions.user.createSuccess),
			switchMap(() =>
				this.vendorAdminService.users().pipe(
					map((users) => VendorAdminActions.users.getSuccess({ users, loading: false })),
					catchError((error) =>
						of(VendorAdminActions.users.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private store: Store<AppState>,
		private vendorAdminService: VendorAdminService
	) {}

	private canUserStoreValue(state: UsersState): boolean {
		return !_.has(state, "error") && !state.loading;
	}
}
